import {
    getListTransactions,getListContentPurchase,downloadSong
} from '@/services/transactions';

const getters = {
    listTransaction: state => state.listTransaction,
    listContentPurchase: state => state.listContentPurchase,
    per_page: state => state.per_page,
};

const actions = {
    async requestListTransactions({ commit, rootGetters }, filter) {
        commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
        let returnRes = {data:[],total:0};
        try {
            const response = await getListTransactions({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },filter);
            commit('SET_LIST', response);
            returnRes = response.data!==undefined?{data:response.data.data,total:response.data.total}:returnRes;
        } catch (err) {
            commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
        } finally {
            commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
        }
        return returnRes;
    },
  async requestListContentPurchase({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = {data:[],total:0};
    try {
      const response = await getListContentPurchase({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },filter);
      commit('SET_LIST_CONTENT', response);
      returnRes = response.data!==undefined?{data:response.data.data,total:response.data.total}:returnRes;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  requestDownloadSong({ commit, rootGetters }, id) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    const response = downloadSong({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] },id);
    return response
  },
};

const mutations = {
    SET_LIST(state, listTransaction) {
        state.listTransaction = listTransaction;
    },
    SET_LIST_CONTENT(state, listContentPurchase) {
      state.listContentPurchase = listContentPurchase;
    },
};

export default {
    namespaced: true,
    state: {
        listTransaction: [],
        listContentPurchase: [],
        per_page: 50,
    },
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Transaction/index.js